/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Arda's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Onur Arda Bodur Portfolio",
    type: "website",
    url: "http://ashutoshhathidara.com/",
  },
};

//Home Page
const greeting = {
  title: "Onur Arda Bodur",
  logo_name: "OnurArdaBodur",
  nickname: "Calender Meshrep",
  subTitle: "Part-Time Guitarist, Full-Time Developer",
  resumeLink:
    "https://drive.google.com/file/d/1F0dH_fB0SmMwjJ6Qdib-FdedocRcL5oo/view?usp=sharing",
  portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/onurardab",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/onurardab",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://tr.linkedin.com/in/onurardabodur",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:onurarda@.alumni.sabanciuniv.edu",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/fluttermonk",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/ardafalan.pdf/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Medium",
    link: "https://calendermeshrep.medium.com/",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Mobile Application Development",
      fileName: "FullStackImg",
      skills: [
        "Strong understanding on mobile app architectures such as MVVM, MVP, VIPER.",
        "Have developed mobile applications on Android using Java & Kotlin.",
        "Experienced on Android App Architechture, RxKotlin and many more mobile specific concepts.",
        "Started developing applications using Swift on UIKit and then switched to SwiftUI.",
        "Familiar to Flutter - Bloc architecture and React - Redux.",
        "Hands on experience with SwiftUI and WidgetKit."
      ],
      softwareSkills: [
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos-java",
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style:{
            color:"#7F52FF"
          }
        },
        {
          skillName: "Android Studio",
          fontAwesomeClassname: "simple-icons:androidstudio",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "IOS",
          fontAwesomeClassname: "simple-icons:ios",
        },
        {
          skillName: "Swift",
          fontAwesomeClassname: "logos-swift",
        },
        {
          skillName: "XCode",
          fontAwesomeClassname: "simple-icons:xcode",
          style:{
            color:"#147EFB"
          }
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "logos-flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "logos-dart",
          style: {
            color: "#0175C2",
          },
        },     
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Expo",
          fontAwesomeClassname: "simple-icons:expo",
          style: {
          },
        },
      ],
    },
    {
      title: "Backend Development",
      fileName: "CloudInfraImg",
      skills: [
        "Experience working on multiple cloud platforms such as AWS, Heroku and Firebase.",
        "Hosting and maintaining websites on virtual machine instances along with integration of databases. (Heroku, MongoDB, MySQL)",
        "Developed both monolithic and microservice applications on various frameworks such as Django, Spring Boot, Flask etc.",
        "Knowledge on serverless file platforms such as S3 and Cloud Storage.",
        "Developed multiple Backend-for-Frontend's for mobile applications active on App Store and Google Play Store. (ESV Mobil etc.)"
      ],
      softwareSkills: [
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20"
          }
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Spring Security",
          fontAwesomeClassname: "simple-icons:springsecurity",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos-java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#777BB4",
          },
        },
        {
          skillName: ".NET",
          fontAwesomeClassname: "simple-icons:dotnet",
          style: {
            color: "#512BD4",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#430098",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "Experience on working with Computer Vision and NLP projects.",
        "Strong understanding on popular Machine Learning and Deep Learning libraries such as Tensorflow, Keras, Sci-Kit etc.",
        "Experienced on various modern libraries such as NumPy, Pandas etc.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Sci-Kit Learn",
          fontAwesomeClassname: "simple-icons:scikit-learn",
          style: {
            backgroundColor: "transparent",
            color: "#F7931E",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#150458",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            backgroundColor: "transparent",
            color: "#013243",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sabancı University",
      subtitle: "B.S. in Computer Science and Engineering",
      logo_path: "logo_sabancirgb.png",
      alt_name: "SU",
      duration: "2016 - 2021",
      descriptions: [
        "- I have studied basic computer science and engineering subjects such as Data Structures and Algorithms, DBMS, Operating Systems, Machine Learing, AI etc.",
        "- Mostly specialized on Mobile Application Development and Backend Development.",
        "- Dean's Honor List"
      ],
      website_link: "https://www.sabanciuniv.edu/",
    },
    {
      title: "İstek Antalya Yeditepe Koleji Lara",
      subtitle: "Middle School and High School",
      logo_path: "istek.png",
      alt_name: "İstek Schools",
      duration: "2009 - 2016",
      descriptions: [
        "- Member of Honor Board",
        "- Graduated with 98.23 overall grade.",
        "- Tübitak Student Reseracher on Applied Biology"
      ],
    },
  ],
};

const certifications = {
  certifications: [

  ],
};
/*
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
  */
// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer (IOS & Android)",
          company: "Yapı Kredi Teknoloji",
          company_url: "https://www.ykteknoloji.com.tr/",
          logo_path: "yktek.jpeg",
          duration: "August 2022 - ∞",
          location: "Hybrid (Remote - Yapı Kredi Banking Base)",
          description:
            "Worked on phase 2 requirements of ESV Mobil and DinamIK Mobil. At the same time, I took part in the process of replatforming the backend-for-frontend layer of the existing DinamIK Mobile application with Java Spring Boot.",
            color: "#0071C5",
        },
        {
          title: "Assistant Software Engineer (IOS & Android)",
          company: "Yapı Kredi Teknoloji",
          company_url: "https://www.ykteknoloji.com.tr/",
          logo_path: "yktek.jpeg",
          duration: "Sept 2021 - Aug 2022",
          location: "Hybrid (Remote - Yapı Kredi Banking Base)",
          description:"Mobile Application Development for Yapı Kredi Bank Human Resources. (ESV Mobil for Yapı Kredi Emekli Sandığı Vakfı and DinamIK Mobil for Yapı Kredi Bank HR.) ESV Mobil can be found on App Store and Google Play Store. DinamIK Mobil was distributed internally to bank employees.",
            color: "#0071C5",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Mobile Development Intern",
          company: "Yapı Kredi Teknoloji",
          company_url: "https://www.ykteknoloji.com.tr/",
          logo_path: "yktek.jpeg",
          duration: "June - Sept 2021",
          location: "Remote",
          description:"Studied mobile application architectures and phenomenals on existing mobil applications. Developed a screen that allows VCard sharing via QR codes using the information obtained.",
            color: "#0071C5",
          },
        {
          title: "Software Development Intern",
          company: "Baykar Teknoloji",
          company_url:"https://baykartech.com/tr/",
          logo_path: "baykar.png",
          duration: "August 2022",
          location: "Baykar Teknoloji",
          description:"Baykar Teknoloji is a private military industry company that produces various combat drones. During the internship, research was conducted on the real-time operating system FreeRTOS.",
          color: "#0071C5",
        },
        {
          title: "Software Development Intern",
          company: "CRS Software",
          company_url:"https://www.crssoft.com",
          logo_path: "crs.png",
          duration: "Jan-Feb 2019",
          location: "YTU Yıldız Teknopark Davutpaşa Campus",
          description: "Developed a Windows Desktop Application using C# and Spotify Web API that allows certain user information to be extracted from Spotify.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Project for Undergraduate Research",
          company: "Sabancı University",
          company_url:"https://pure.sabanciuniv.edu",
          logo_path: "pure-logo.png",
          duration: "Sept 2019 - Feb 2019",
          location: "Sabancı University",
          description:"Project for Undergraduate Research, PURE for short is a research program that allows undergraduate students to work on graduate level reserach projects as academic staffs.",
            color: "#0071C5",
          },
        {
          title: "Founding Member",
          company: "Kıssa (Sabancı University Short-Film Club)",
          company_url:"https://clubs.sabanciuniv.edu/tr/c/kissa",
          logo_path: "kıssa.png",
          duration: "Jan 2018 - ∞",
          location: "Sabancı University",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
            color: "#0071C5",
          },
        {
          title: "Civic Involvement Projects",
          company: "Sabancı University",
          company_url:
            "https://cip.sabanciuniv.edu/en",
          logo_path: "cip.png",
          duration: "March 2017 - June 2017",
          location: "Sabancı University",
          description:"Various activities were carried out in line with the pre-determined curricula for primary school students in regions with financial difficulties.",
            color: "#0071C5",
          },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "arda.png",
    description:
      "I am active on almost every social media. You can message me and if you do, I will reply within 24 hours. I can help you with almost anything related to software development.",
  },
  blogSection: {

  },
  addressSection: {
    title: "Address",
    subtitle:
      "Hüseyin Hüsnü Paşa Sk.Feneryolu, 34724 Kadıköy/İstanbul",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/VKoJaT8kR3c8u8Nk7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+90 (507) 007 66 84",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
